import React from "react";
import { jsx } from "slate-hyperscript";
import Styles from "../Editor.module.scss";
import {
    BlockHandler,
    ElementType,
} from "./base";

BlockHandler.register(ElementType.HEADER, {
    nodeTypes: ["H1", "H2", "H3", "H4", "H5", "H6"],
    toBlock: child => <h1 className={Styles.header}>{child}</h1>,
    serialize: child => `<h1>${child}</h1>`,
    deserialize: children => jsx("element", { type: ElementType.HEADER }, children),
});
